import { leerRechazoBinary } from '@lib/rechazo-binary';

/**
 * Un rechazo de Binary: el motivo en texto común y, si hace falta, una pastilla
 * corta "Rechazado por Binary" arriba.
 *
 * Antes el mensaje entero iba adentro de la pastilla roja (`.status` es una
 * píldora): en las filas angostas quedaba un bloque rojo de varias líneas que
 * además no decía qué corregir ("No se pudo procesar la solicitud N.").
 */
export function RechazoBinary({
  mensaje,
  at,
  intentos,
  conPastilla = false,
  detalleEnLinea = true,
}: {
  mensaje?: string | null;
  /** Fecha del último intento (ISO). */
  at?: string | null;
  intentos?: number | null;
  /** Muestra la pastilla "Rechazado por Binary" (fuera de una columna que ya lo dice). */
  conPastilla?: boolean;
  /** Solicitud, fecha e intentos debajo del motivo; si es false van al tooltip. */
  detalleEnLinea?: boolean;
}) {
  const r = leerRechazoBinary(mensaje);
  if (!r) return <span className="text-element-mid">—</span>;

  const detalle = [
    r.solicitud ? `Solicitud ${r.solicitud}` : null,
    at ? `último intento ${new Date(at).toLocaleString('es-AR')}` : null,
    intentos && intentos > 1 ? `${intentos} intentos` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div data-testid="rechazo-binary" title={detalleEnLinea ? undefined : detalle || undefined}>
      {conPastilla && (
        <span className="status status-error" style={{ fontSize: 11, padding: '2px 8px' }}>
          Rechazado por Binary
        </span>
      )}
      <div
        style={{
          fontSize: 12,
          marginTop: conPastilla ? 4 : 0,
          whiteSpace: 'normal',
          color: r.sinMotivo ? 'var(--color-element-mid)' : undefined,
        }}
      >
        {r.motivo}
        {r.sinMotivo && ' Va a aparecer en el próximo intento.'}
      </div>
      {detalleEnLinea && detalle && (
        <div className="text-element-mid" style={{ fontSize: 11, marginTop: 2 }}>
          {detalle}
        </div>
      )}
    </div>
  );
}
